import { render, staticRenderFns } from "./Convenios.vue?vue&type=template&id=4aee8e3f&"
import script from "./Convenios.vue?vue&type=script&lang=ts&"
export * from "./Convenios.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports